export default {
  gameWidth: 900,
  gameHeight: 720,
  localStorageName: 'phaseres6webpack'
}



// WEBPACK FOOTER //
// ./src/game/config.js